<template>
  <div class="login-wrapper">
    <div class="bg-orb bg-orb-1"></div>
    <div class="bg-orb bg-orb-2"></div>
    <div class="bg-orb bg-orb-3"></div>

    <div class="login-center">
      <div class="login-card glass-strong">
        <!-- Logo -->
        <div class="login-logo-area">
          <img src="@/assets/logo-white.png" alt="Fino Trato" class="login-logo" />
          <div>
            <h1 class="login-brand">FINO TRATO</h1>
            <p class="login-brand-sub">Painel Administrativo</p>
          </div>
        </div>

        <div class="login-divider"></div>

        <!-- Formulário -->
        <form @submit.prevent="fazerLogin" class="login-form">
          <div class="login-field">
            <label class="field-label">E-mail</label>
            <div class="field-input-wrap">
              <v-icon dark class="field-icon" size="18">mdi-email-outline</v-icon>
              <input
                v-model="email"
                type="email"
                class="glass-input login-input"
                placeholder="admin@finotrato.com"
                autocomplete="email"
                :disabled="loading"
                required
              />
            </div>
          </div>

          <div class="login-field">
            <label class="field-label">Senha</label>
            <div class="field-input-wrap">
              <v-icon dark class="field-icon" size="18">mdi-lock-outline</v-icon>
              <input
                v-model="senha"
                :type="showPassword ? 'text' : 'password'"
                class="glass-input login-input"
                placeholder="••••••••••••"
                autocomplete="current-password"
                :disabled="loading"
                required
              />
              <button
                type="button"
                class="toggle-pass"
                @click="showPassword = !showPassword"
                tabindex="-1"
              >
                <v-icon dark size="17">{{ showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
              </button>
            </div>
          </div>

          <!-- Erro -->
          <transition name="fade-err">
            <div v-if="erro" class="login-error">
              <v-icon dark size="15">mdi-alert-circle-outline</v-icon>
              {{ erro }}
            </div>
          </transition>

          <button type="submit" class="btn-primary login-btn" :disabled="loading">
            <v-icon dark size="17" :class="{ spin: loading }">
              {{ loading ? 'mdi-loading' : 'mdi-shield-account' }}
            </v-icon>
            {{ loading ? 'Verificando...' : 'Entrar no Painel' }}
          </button>
        </form>

        <router-link to="/" class="login-back-link">
          <v-icon dark size="13">mdi-arrow-left</v-icon>
          Voltar para o início
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginView",

  data() {
    return {
      email: "",
      senha: "",
      showPassword: false,
      loading: false,
      erro: "",
    };
  },

  mounted() {
    // Se já tem token válido, redireciona direto
    const token = localStorage.getItem("ft_admin_token");
    if (token) this.$router.replace("/admin");
  },

  methods: {
    async fazerLogin() {
      this.erro = "";
      this.loading = true;
      try {
        const { data } = await axios.post(`${this.$api}/api/auth/login`, {
          email: this.email,
          senha: this.senha,
        });

        localStorage.setItem("ft_admin_token", data.token);
        localStorage.setItem("ft_admin_nome", data.nome);
        // Aplica o token em todos os requests futuros
        axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;

        this.$router.push("/admin");
      } catch (err) {
        this.erro =
          err.response?.data?.msg || "Erro ao conectar com o servidor.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 20px;
}

.login-center {
  width: 100%;
  max-width: 400px;
  position: relative;
  z-index: 1;
}

.login-card {
  border-radius: 28px;
  padding: 40px 36px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Logo */
.login-logo-area {
  display: flex;
  align-items: center;
  gap: 14px;
  justify-content: center;
}

.login-logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
  filter: drop-shadow(0 3px 10px rgba(44, 183, 177, 0.5));
}

.login-brand {
  color: #fff;
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 3px;
  margin: 0;
}

.login-brand-sub {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.75rem;
  margin: 3px 0 0;
  letter-spacing: 0.5px;
}

.login-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}

/* Form */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.field-label {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.field-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.field-icon {
  position: absolute;
  left: 12px;
  color: rgba(255, 255, 255, 0.35) !important;
  pointer-events: none;
}

.login-input {
  padding-left: 38px !important;
  padding-right: 38px !important;
}

.toggle-pass {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  padding: 4px;
  transition: color 0.2s;
}

.toggle-pass:hover {
  color: rgba(255, 255, 255, 0.8);
}

/* Error */
.login-error {
  background: rgba(231, 76, 60, 0.15);
  border: 1px solid rgba(231, 76, 60, 0.35);
  border-radius: 10px;
  color: #ff8a7a;
  font-size: 0.82rem;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.fade-err-enter-active,
.fade-err-leave-active {
  transition: all 0.25s ease;
}
.fade-err-enter,
.fade-err-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* Buttons */
.login-btn {
  width: 100%;
  justify-content: center;
  border-radius: 12px;
  padding: 14px;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.login-back-link {
  color: rgba(255, 255, 255, 0.38);
  font-size: 0.78rem;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: color 0.2s;
}

.login-back-link:hover {
  color: rgba(255, 255, 255, 0.75);
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
